import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import WorkMediaRotation from './WorkMediaRotation'
import WorkResourcesSeed from './WorkResourcesSeed'
import WorkExemplarMarker from './WorkExemplarMarker'

@autobind
class WorkMedia extends Component {
  render () {
    var media = this.props.media && this.props.media.map((medium, index) => {
      return (
        <figure className='workMedia__medium' key={medium.id}>
          {this.props.user.policy && this.props.user.policy.can_add_resource && this.props.lesson && <WorkResourcesSeed lessonId={this.props.lesson.id} onResourceAddition={this.props.onResourceAddition} />}
          {this.props.user.policy && this.props.user.policy.can_mark_as_exemplar && <WorkExemplarMarker onExemplarMarked={this.props.onExemplarMarked} workId={this.props.id} isExemplar={this.props.exemplar} />}
          {medium.policy && medium.policy.can_rotate && <WorkMediaRotation medium={medium} index={index} onImageRotation={this.props.onImageRotation} />}
          {this.props.can_rotate && <WorkMediaRotation medium={medium} index={index} onImageRotation={this.props.onImageRotation} />}
          {this.props.media.length > 1 && <div className='workMedia__pagination'>{index + 1} of {this.props.media.length}</div>}
          <img src={medium.image_url} className='workMedia__picture' />
        </figure>
      )
    })

    return (
      <section className='workMedia'>
        {media}
      </section>
    )
  }
}

export default WorkMedia

WorkMedia.propTypes = {
  media: PropTypes.array,
  onImageRotation: PropTypes.func,
  onResourceAddition: PropTypes.func,
  onExemplarMarked: PropTypes.func,
  can_rotate: PropTypes.bool,
  id: PropTypes.string,
  exemplar: PropTypes.bool,
  lesson: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkMedia.js